import {
  CLEAR_ALL_TRANSACTIONS,
  CLEAR_EXTRA_TRANSACTION_ITEMS,
  CLEAR_TRANSACTIONS_WITHOUT_FILTERS,
  CLEAR_TRANSACTIONS_WITH_FILTERS,
  GET_ALL_TRANSACTIONS,
  GET_EXTRA_TRANSACTION_ITEMS,
  GET_TRANSACTIONS,
  TRANSACTIONS_FILTER,
} from 'redux/actions/types';

const initialState = {
  isLoading: true,
  extraLoading: true,
  transactions: null,
  terminalsItem: null,
  walletItems: null,
  formItems: null,
};

const transactions = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_TRANSACTIONS:
      return {
        ...state,
        transactions: data.transactions,
        terminalItems: data.terminals,
        walletItems: data.wallets,
        formItems: data.paymentForms,
        isLoading: false,
      };
    case GET_EXTRA_TRANSACTION_ITEMS:
      return {
        ...state,
        extraTransactionItems: {
          ...state.extraTransactionItems,
          data: data.transactions,
        },
        extraLoading: false,
      };
    case CLEAR_EXTRA_TRANSACTION_ITEMS:
      return {
        ...state,
        extraTransactionItems: [],
        extraLoading: true,
      };
    case TRANSACTIONS_FILTER:
      return {
        ...state,
        filter: data,
      };
    case GET_ALL_TRANSACTIONS:
      return {
        ...state,
        allTransactions: data,
      };
    case CLEAR_TRANSACTIONS_WITHOUT_FILTERS:
      return { ...initialState, filter: state.filter };

    case CLEAR_TRANSACTIONS_WITH_FILTERS:
      return {
        isLoading: true,
      };
    case CLEAR_ALL_TRANSACTIONS:
      return {
        ...state,
        allTransactions: null,
      };
    default:
      return state;
  }
};

export default transactions;
